import { isMagicbuyProject } from '@g/utils/projectUtils'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.get('/jyo/v1frontend/cnorder/index', params)
  },
  create ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project) && !params.payMethod) {
      params = { ...params, payMethod: 'creditdg' }
    }
    return rootState.axios.post('/jyo/v1frontend/cnorder/create', params)
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/cnorder/update', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/cnorder/view', { params })
  },
  kdTracking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/cnorder/kd-tracking', { params })
  },
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/cnorder/prepare', params)
  },
  refund ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/cnorder/refund', params)
  },
  pay ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project)) {
      if (!params.payMethod) {
        params = { ...params, payMethod: 'creditdg' }
      }
    }
    return rootState.axios.post('/jyo/v1frontend/cnorder/pay', params)
  },
  updateUrgent ({ state, commit, rootState }, params) {
    console.log('updateUrgent', params)
    return rootState.axios.post('/jyo/v1frontend/cnorder/update-urgent', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
